import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OktaCallbackComponent } from '@okta/okta-angular';
import { TabTitleStrategyService } from '@sc/data-access-translation';
import { AuthenticationGuard } from '@sc/feature-auth-okta';
import { HomeContainer } from './containers/home/home.container';
import { UnauthorizedContainer } from './containers/unauthorized/unauthorized.container';

const CALLBACK_PATH = 'login/callback';

const routes: Routes = [
  {
    path: '',
    component: HomeContainer,
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.customer.Home',
    },
  },
  {
    path: 'index.html',
    component: HomeContainer,
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.customer.Home',
    },
  },
  {
    path: 'customer-declaration',
    canActivate: [AuthenticationGuard],
    loadChildren: () =>
      import('@sc/feature-customer-declaration').then(
        (module) => module.routes
      ),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.customer.Home',
    },
  },
  {
    path: 'customer-pre-declaration',
    canActivate: [AuthenticationGuard],
    loadChildren: () =>
      import('@sc/feature-customer-pre-declaration').then(
        (module) => module.routes
      ),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.customer.PreDeclaration',
    },
  },
  {
    path: 'open-arrival',
    loadChildren: () =>
      import('@sc/feature-customer-open-arrival').then(
        (module) => module.routes
      ),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.customer.OpenArrival',
    },
  },
  {
    path: `cta/:encryptedInfo`,
    loadChildren: () =>
      import('@sc/feature-cta').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.customer.CTA',
    },
  },
  {
    path: `cta`,
    loadChildren: () =>
      import('@sc/feature-cta').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.customer.CTA',
    },
  },
  {
    path: 'appointments-suggestion-validation',
    canActivate: [AuthenticationGuard],
    loadChildren: () =>
      import('@sc/feature-appointment-suggestion-validation').then(
        (module) => module.routes
      ),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.customer.AppointmentSuggestion',
    },
  },
  {
    path: 'images-upload',
    canActivate: [AuthenticationGuard],
    loadChildren: () =>
      import('@sc/feature-image-upload').then((module) => module.routes),
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.customer.UploadDocuments',
    },
  },
  {
    path: 'unauthorized',
    component: UnauthorizedContainer,
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.customer.Unauthorized',
    },
  },
  {
    path: CALLBACK_PATH,
    component: OktaCallbackComponent,
    data: {
      [TabTitleStrategyService.TAB_TITLE_KEY]:
        'GlobalApplicativeConstants.tabTitles.pageTitles.customer.Home',
    },
  },
  { path: '**', redirectTo: 'unauthorized' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
